const countriesMapping = {
  pt: "pt",
  en: "en",
  es: "es",
};

export type Country = keyof typeof countriesMapping;

export const defaultCountry = countriesMapping.pt;

export const getSimpleCountryCode = (code: string): string => {
  return code.substring(0, 2);
};
